import {
  media,
} from 'ia-react-core';
import styled from 'styled-components';

export const StyledControlMessageText = styled.span`
  margin-bottom: 12px;
  font-size: 14px;
  display: inline-block;
`;

export const StyledTextControlWrapper = styled.div`
  > span > input {
    width: 100%;
    ${media.sm`
        width: 50%;
    `};
    }
`;
export const StyledTip = styled.span`
  span[type="button"] {
    transform: translateY(5px);
    padding-left: 15px;
    padding-top: 8px;
  }
  
  span[type="button"]::after {
    transform: translate(3px, -4px);
  }
`;

export const StyledToolTipContainer = styled.div`
  display: inline;
  position: absolute;
  margin-left: 5px;
  margin-top: 0px;
`;
